(() => {
  const init = root => {
    root.querySelectorAll('[data-tdp-controls]').forEach(config => {
      const container = config.closest('[data-section-type="product"]');
      if (!container || container.dataset.tdpReady) return;
      const product = JSON.parse(document.getElementById('ProductJson-' + container.dataset.sectionId).textContent);
      const selects = [...container.querySelectorAll('.single-option-selector')];
      if (selects.length < product.options.length) return;
      container.dataset.tdpReady = 'true';
      const words = JSON.parse(config.textContent);
      const colorNames = words.colors;
      const swatches = {'Black':'#1c1c1c','Noir':'#1c1c1c','Navy':'#182638','Navy Blazer':'#182638','Maroon':'#692e40','Team Royal':'#294b9c','Military Green':'#666b44','Heather Raspberry':'#b5436b','Heather True Royal':'#4776b5','Light Blue':'#b8d3e2','Light Pink':'#efc9d3','Dark Heather':'#606063','White':'#fff','Blanc':'#fff','Sport Grey':'#aaa'};
      const groups = [];
      selects.forEach((select, index) => {
        const name = product.options[index];
        const size = /^(size|taille|grandeur)$/i.test(name);
        const color = /^(colou?r|couleur)$/i.test(name);
        if (!size && !color) return;
        const wrapper = select.closest('.selector-wrapper');
        const group = document.createElement('fieldset'); group.className = 'tdp-options';
        const legend = document.createElement('legend'); legend.textContent = size ? words.size : words.color; group.appendChild(legend);
        const buttons = document.createElement('div'); buttons.className = 'tdp-options__buttons'; group.appendChild(buttons);
        [...select.options].forEach(option => {
          const button = document.createElement('button'); button.type = 'button'; button.className = 'tdp-option'; button.dataset.value = option.value;
          if (color && swatches[option.value]) {const swatch = document.createElement('span');swatch.className='tdp-swatch';swatch.style.backgroundColor=swatches[option.value];swatch.setAttribute('aria-hidden','true');button.appendChild(swatch);}
          button.appendChild(document.createTextNode(color ? (colorNames[option.value] || option.textContent) : option.textContent));
          button.addEventListener('click', () => {select.value=option.value;select.dispatchEvent(new Event('change',{bubbles:true}));update();});
          buttons.appendChild(button);
        });
        wrapper.insertAdjacentElement('beforebegin',group);wrapper.classList.add('tdp-native-control');
        groups.push({group,select,index,size,color});
      });
      const update = () => {
        groups.forEach(({group,select,index,size}) => {
          group.querySelectorAll('button').forEach(button => {
            button.setAttribute('aria-pressed',String(button.dataset.value===select.value));
            button.disabled = !product.variants.some(variant => variant.available && variant.options[index]===button.dataset.value && (!size || selects.every((other,j)=> j===index || variant.options[j]===other.value)));
          });
        });
      };
      selects.forEach(select=>select.addEventListener('change',update));update();
      const sizeGroup = groups.find(group=>group.size);
      const guide = container.querySelector('.tdp-size-help');
      if (guide && sizeGroup) sizeGroup.group.insertAdjacentElement('afterend',guide);
    });
  };
  const setup = () => {
    init(document);
    document.querySelectorAll('[data-tdp-image]').forEach(button => {
      if (button.dataset.tdpBound) return;
      button.dataset.tdpBound = 'true';
      button.addEventListener('click', () => {
        const container = button.closest('[data-section-type="product"]');
        container.querySelectorAll('.product__photo--variant-wrapper').forEach(photo => photo.classList.toggle('hide',photo.dataset.imageId!==button.dataset.tdpImage));
      });
    });
  };
  document.addEventListener('DOMContentLoaded', () => {
    setup();
    const section = document.querySelector('#shopify-section-product-template');
    if (!section || !section.querySelector('[data-tdp-controls]')) return;
    const observer = new MutationObserver(() => {
      init(document);
      if (section.querySelector('[data-tdp-ready]')) observer.disconnect();
    });
    if (!section.querySelector('[data-tdp-ready]')) observer.observe(section,{childList:true,subtree:true});
  });
  window.addEventListener('load',setup);
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();

(function () {
  function enhanceSizeTables() {
    document.querySelectorAll('[data-tdp-size-table]').forEach(function (wrapper) {
      const table = wrapper.querySelector('table');
      if (!table || table.dataset.tdpEnhanced) return;
      table.dataset.tdpEnhanced = 'true';
      const rows = Array.from(table.rows);
      const hasCentimeters = /\bcm\b|centim/i.test(table.textContent);
      rows.forEach(function (row, index) {
        const cells = Array.from(row.cells);
        if (!cells.length) return;
        if (index === 0) {
          if (!cells[0].textContent.trim()) cells[0].textContent = wrapper.dataset.sizeLabel;
          cells.forEach(function (cell) {
            const sizeNames = {Small: 'S', Medium: 'M', Large: 'L', XLarge: 'XL', '2XLarge': '2XL', '3XLarge': '3XL'};
            const text = cell.textContent.trim();
            if (sizeNames[text]) cell.textContent = sizeNames[text];
          });
        }
        const label = cells[0].textContent.trim();
        const isInches = /inch|pouce/i.test(label);
        const length = /length|longueur/i.test(label);
        const width = /width|largeur/i.test(label);
        if (!isInches || (!length && !width)) return;
        const translatedLabel = length ? wrapper.dataset.lengthLabel : wrapper.dataset.widthLabel;
        cells[0].textContent = translatedLabel + ' (' + wrapper.dataset.inchesLabel + ')';
        if (hasCentimeters) return;
        const values = cells.slice(1).map(function (cell) { return Number(cell.textContent.trim().replace(',', '.')); });
        if (values.some(function (value) { return !Number.isFinite(value) || value <= 0; })) return;
        const cmRow = document.createElement('tr');
        const heading = document.createElement('th');
        heading.scope = 'row';
        heading.textContent = translatedLabel + ' (cm)';
        cmRow.appendChild(heading);
        values.forEach(function (value) { const cell = document.createElement('td'); cell.textContent = (Math.round(value * 25.4) / 10).toFixed(1); cmRow.appendChild(cell); });
        row.after(cmRow);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhanceSizeTables); else enhanceSizeTables();
  document.addEventListener('shopify:section:load', enhanceSizeTables);
})();

(function () {
  function initCommerceFixes() {
    document.querySelectorAll('[data-tdp-event]').forEach(function (root) {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const select = root.querySelector('[data-tdp-event-select]');
      if (!select || !select.options.length) return;
      const update = function () {
        const option = select.options[select.selectedIndex];
        const available = option.dataset.available === 'true';
        root.querySelector('[data-tdp-event-price]').textContent = option.dataset.price;
        root.querySelector('[data-tdp-event-selection]').textContent = option.dataset.title;
        root.querySelector('[data-tdp-event-buy]').disabled = !available;
        root.querySelector('[data-tdp-event-buy]').hidden = !available;
        root.querySelector('[data-tdp-event-unavailable]').hidden = available;
        root.querySelector('[data-tdp-event-inquire]').href = 'mailto:tropdepoutine@gmail.com?subject=' + encodeURIComponent('Disponibilité : ' + option.dataset.title);
      };
      select.addEventListener('change', function () {
        update();
        const url = new URL(window.location.href);
        url.searchParams.set('variant', select.value);
        window.history.replaceState({}, '', url);
      });
      update();
    });
    const labels = document.getElementById('TdpCartLabels');
    if (!labels) return;
    const colors = JSON.parse(labels.textContent).colors;
    const translateCart = function () {
      document.querySelectorAll('.ajaxcart__product-meta, [data-tdp-variant-label]').forEach(function (label) {
        const text = label.textContent.trim();
        const translated = text.split(' / ').map(function (part) { return colors[part] || part; }).join(' / ');
        if (text !== translated) label.textContent = translated;
      });
    };
    translateCart();
    const drawer = document.getElementById('CartDrawer');
    if (drawer && !drawer.dataset.tdpLabelsReady) {
      drawer.dataset.tdpLabelsReady = 'true';
      new MutationObserver(translateCart).observe(drawer, {childList: true, subtree: true});
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initCommerceFixes); else initCommerceFixes();
  document.addEventListener('shopify:section:load', initCommerceFixes);
})();
